export default "__VITE_ASSET__DFLPMSFO__"